import React from 'react';
import { useNavigate } from 'react-router-dom'

// Material
import Grid from '@mui/material/Grid'
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography'

// Components
import { DataGrid, ViewButton } from '@arredo/reactjs-ui';
import Filters from './ProductHistoryFilters';

// Hooks
import useQueryString from '../../../hooks/queryString/useQueryString';
import useProductHistory from '../../../hooks/product-history/useProductHistory';

import { columns } from '../../../models/MovementHistoryEntity';

const ProductHistoryView = () => {
    const push = useNavigate();
    const { filters, setParameterSearch } = useQueryString();
    const { movements, totalPage, stockQuantity, loading } = useProductHistory(filters);

    const handleChangePage = (e, page) =>
        setParameterSearch({ pageNumber: Number(page) });

    return (
        <>
            <Grid container direction='column' spacing={1}>
                <Grid>
                    <Box paddingX={2} paddingY={1} component={Paper}>
                        <Typography component='h2' variant='h4' align='center'>
                            Historial de producto
                        </Typography>
                    </Box>

                </Grid>
                <Grid>
                    <Filters filters={filters} setFilters={setParameterSearch} totalStockQuantity={stockQuantity} />
                </Grid>
                <Grid>
                    <DataGrid
                        columns={columns}
                        rows={movements}
                        loading={loading}
                        paginationProps={{
                            count: totalPage,
                            page: Number(filters?.pageNumber || 1),
                            onChange: handleChangePage
                        }}
                        actions={({ row }) => (
                            <>
                                <ViewButton to={`/movements/detail/${row.idMovement}`} />
                            </>
                        )}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ProductHistoryView;